<template>
    <communities-grid :communities="communities" :loading="loading" />
</template>
<script>
import CommunitiesGrid from '@/components/CommunitiesGrid';
import CommunityModalResume from '@/components/CommunityModalResume';
import _ from 'underscore';
export default {
    components: {
        CommunitiesGrid,
        CommunityModalResume,
    },
    props: {},
    data() {
        return {
            community: null,
            showModal: false,
            loading: true,
        };
    },

    computed: {
        communities() {
            return this.$store.getters.communities;
        },
    },
    mounted() {
        this.$store
            .dispatch('fetchMyCommunities')
            .catch(() => {
                console.error('failed to fetch communities content');
            })
            .finally(() => {
                this.loading = false;
            });
    },
    beforeDestroy() {
        this.$store.commit('SET_COMMUNITIES', []);
    },
};
</script>
